import React, { useState, useEffect, useContext } from "react";
import DashboardLayout from "../../../layoutcontainers/DashboardLayout";
import ConfirmationDialog from "../../../components/Dialog/ConfirmationDialog";
import axios from "axios";
import { useLocation, useNavigate } from "react-router-dom";
import {
  Card,
  CardContent,
  CardHeader,
  FormControl,
  FormHelperText,
  Stack,
  ButtonGroup,
} from "@mui/material";
import Grid from "@mui/material/Grid2";
import MaterialTypography from "../../../components/MaterialTypography";
import MaterialBox from "../../../components/MaterialBox";
import MaterialInput from "../../../components/MaterialInput";
import MaterialButton from "../../../components/MaterialButton";
import MaterialSnackbar from "../../../components/MaterialSnackbar";
import NotificationsIcon from "@mui/icons-material/Notifications";
import BASEURL from "../../Utils/Baseurl";
import MaterialSelect from "../../../components/MasterSelect";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import { useUserDetails } from "../../../context/auth";
import CurrencyRupeeIcon from "@mui/icons-material/CurrencyRupee";
import Swal from "sweetalert2";

const AddOT = () => {
  const navigate = useNavigate();
  const { display, setdisplay, AccessData } = useUserDetails();

  const [id, setId] = useState(null);
  const [viewData, setViewData] = useState("");
  const [update, setupdate] = useState(false);
  const [pageState, setPageState] = useState({
    loading: false,
    error: false,
    message: "",
    state: "init",
  });
  const [confirmationDialog, setConfirmationDialog] = useState({
    open: false,
    title: "",
    message: "",
    showCancel: true, 
    customSection: null,
    onConfirm: () => {},
    onCancel: () => {},
  });
  const [snackBar, setSnackBar] = useState({
    Success: false,
    Error: false,
  });

  const [togglePage, setTogglePage] = useState({
    view: false,
    edit: false,
  });

  const [OTData, setOTData] = useState({
    maximumHours: "",
    otPerhourCharge: "",
    maximumHoursStatus: "unchecked",
    otPerhourChargeStatus: "unchecked",
  });

  const [resource, setResource] = useState({
    maximumHours: [],
  });

  const departmentOptions = [
    { value: 1, label: "Human Resources" },
    { value: 2, label: "Engineering" },
    { value: 3, label: "Marketing" },
    { value: 4, label: "Sales" },
    { value: 5, label: "Customer Support" },
  ];

  const [originalDesigntionData, setOriginalDesignationData] = useState({
    maximumHours: "",
    otPerhourCharge: "",
  });

  useEffect(() => {
    const queryParams = new URLSearchParams(window.location.search);
    const id = queryParams.get("id");
    setId(id);
    onDepartmentSubmit();
    if (id) {
      getInitData(id);
    }
  }, []);

  useEffect(() => {
    onfilterData();
  }, [viewData]);

  let houroption = [
    { value: "1", label: "1 Hour" },
    { value: "2", label: "2 Hours" },
    { value: "3", label: "3 Hours" },
    { value: "4", label: "4 Hours" },
  ];

  const convertSecondsToHours = (seconds) => {
    return Math.floor(seconds / 3600); // Return only the number of hours
  };

  const getInitData = async (id) => {
    const query = `
query GetOTById($id: String!) {
  OTById(id: $id) {
    success
    message
    error
    data {
      id
      maximumHours
      otPerhourCharge
      createdAt
      updatedAt
    }
  }
}
`;
    try {
      setPageState({ ...pageState, loading: true });
      const response = await axios.post(
        BASEURL,
        {
          query: query,
          variables: { id },
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
      console.log("responsesss:", response);
      // Extract Leavetype data from the response
      const departmentRowdata = response.data.data.OTById?.data[0];
      console.log("departmentRowdata:", departmentRowdata);

      //   let alldata = departmentRowdata.map((val) => ({
      //     id: val.id,
      //     maximumHours: convertSecondsToHours(val.maximumHours)+' '+"Hours",
      //     otPerhourCharge: val.otPerhourCharge,
      // }));
      //   const maximumHoursData =
      //     response.data.data.getDesignationById?.maximumHours;

      let data = convertSecondsToHours(departmentRowdata.maximumHours);

      console.log("datadata:", data);

      const obj = {
        maximumHours: {
          value: convertSecondsToHours(departmentRowdata.maximumHours),
          label:
            convertSecondsToHours(departmentRowdata.maximumHours) +
            " " +
            "Hours",
        },
        otPerhourCharge: departmentRowdata.otPerhourCharge,
      };
      // setViewData(obj);
      setOTData({
        maximumHours: {
          value: convertSecondsToHours(departmentRowdata.maximumHours),
          label:
            convertSecondsToHours(departmentRowdata.maximumHours) +
            " " +
            "Hours",
        },
        otPerhourCharge: departmentRowdata.otPerhourCharge,
      });

      setOriginalDesignationData(obj);

      setTogglePage({
        ...togglePage,
        view: true,
      });
      setPageState({ ...pageState, loading: false, state: "success" });
    } catch (error) {
      console.error("ResponseError:", error);
      setConfirmationDialog({
        open: true,
        title: "Error message",
        message:
          "Sorry for your inconvience, there is some issue in our network. Please try again later.",
        showCancel: true,
        showConfirm: false,

        onCancel: () => {
          setConfirmationDialog({
            ...confirmationDialog,
            open: false,
          });
        },
      });
    }
  };

  console.log("OTData:", OTData);

  const onEditDesignationSubmit = async () => {
    const query = ` 
   mutation updateOTMaster($id: ID!, $input: OTMasterInput!) {
  updateOtMaster(id: $id, input: $input) {
    success
    message
    maximumHours
    otPerhourCharge
  }
}


`;

    try {
      const response = await axios({
        url: BASEURL,
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        data: JSON.stringify({
          query,
          variables: {
            id: id,
            input: {
              otPerhourCharge: OTData.otPerhourCharge,
              maximumHours: OTData.maximumHours.value,
            },
          },
        }),
      });

      console.log("response:", response.data.data.updateOtMaster);
      let result = response.data.data.updateOtMaster;

      setConfirmationDialog({
        ...confirmationDialog,
        open: false,
      });
      setSnackBar({
        ...snackBar,
        Success: true,
      });
      if (result.success) {
        Swal.fire({
          position: "center",
          icon: "success",
          title: "OT Updated Successfully!",
          showConfirmButton: false,
          timer: 2500,
        });
        navigate("/OTMaster");
      }
    } catch (error) {
      console.error("responseError:", error);
      setConfirmationDialog({
        open: true,
        title: "Error message",
        message:
          "Sorry for your inconvience, there is some issue in our network. Please try again later.",
        showCancel: true,
        showConfirm: false,

        onCancel: () => {
          setConfirmationDialog({
            ...confirmationDialog,
            open: false,
          });
        },
      });
    }
  };

  const AddDelete = () => {
    setConfirmationDialog({
      open: true,
      title: "Confirmation",
      message: "Are you sure do you want to Delete your details.",
      showCancel: true,
      showConfirm: true,
      onConfirm: () => {
        onDeleteDesignationSubmit();
        setConfirmationDialog({
          ...confirmationDialog,
          open: false,
        });
      },
      onCancel: () => {
        setConfirmationDialog({
          ...confirmationDialog,
          open: false,
        });
      },
    });
  };

  const onDeleteDesignationSubmit = async () => {
    const query = `
          mutation deleteOTMaster($id: ID!) {
  deleteOtMaster(id: $id) {
    success
    message
  }
}

        `;

    try {
      const response = await axios.post(BASEURL, {
        query: query,
        variables: {
          id: id,
        },
      });

      if (response.data.data.deleteOtMaster.success) {
        console.log("Designation deleted successfully!");
       Swal.fire({
              position: "center",
              icon: "success",
              title: "OT Deleted Successfully!",
              showConfirmButton: false,
              timer: 2500,
            });
        navigate("/OTMaster");
      } else {
        console.log(
          "Error deleting designation:",
          response.data.data.deleteOtMaster.message
        );
      }
    } catch (error) {
      console.error("An error occurred while deleting the designation:", error);
      setConfirmationDialog({
        open: true,
        title: "Error message",
        message:
          "Sorry for your inconvience, there is some issue in our network. Please try again later.",
        showCancel: true,
        showConfirm: false,

        onCancel: () => {
          setConfirmationDialog({
            ...confirmationDialog,
            open: false,
          });
        },
      });
    }
  };

  const onDepartmentSubmit = async () => {
    const query = `query {
            allDepartment {
                id
                departmentCode
            }
        }`;

    try {
      setPageState({ ...pageState, loading: true });

      const response = await axios.post(
        BASEURL,
        {
          query: query,
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      // Extract department data from the response
      const departmentListdata = response.data.data.allDepartment;
      console.log(departmentListdata,"departttt");
      
      setResource({
        ...resource,
        maximumHours: departmentListdata,
      });
      setPageState({ ...pageState, loading: false, state: "success" });

      console.log("Response departmentListdata:", departmentListdata);
    } catch (error) {
      console.error("ResponseError:", error);
      setPageState({
        ...pageState,
        loading: false,
        error: true,
        message: error.message,
      });
    }
  };
  console.log("OTDATA:", OTData);

  const onDesignationSubmit = async () => {
    const query = `mutation AddOTMaster($input: OTMasterInput!) {
            addOtMaster(input: $input) {
              success
              message
              maximumHours
              otPerhourCharge
            }
          }`;

    try {
      const response = await axios({
        url: BASEURL,
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        data: JSON.stringify({
          query,
          variables: {
            input: {
              otPerhourCharge: OTData.otPerhourCharge,
              maximumHours: OTData.maximumHours.value,
            },
          },
        }),
      });

      console.log("response:", response.data);
      if (response.data.data.addOtMaster.success) {
        Swal.fire({
          position: "center",
          icon: "success",
          title: "OT Added Successfully!",
          showConfirmButton: false,
          timer: 2500,
        });
        navigate("/OTMaster");
      }
      setConfirmationDialog({
        ...confirmationDialog,
        open: false,
      });
      // setSnackBar({
      //   ...snackBar,
      //   Success: true,
      // });
    } catch (error) {
      console.error("responseError:", error);
      setConfirmationDialog({
        open: true,
        title: "Error message",
        message:
          "Sorry for your inconvience, there is some issue in our network. Please try again later.",
        showCancel: true,
        showConfirm: false,

        onCancel: () => {
          setConfirmationDialog({
            ...confirmationDialog,
            open: false,
          });
        },
      });
    }
  };

  const handleDesignationDatachange = (event, selectEvent) => {
    console.log("selectEvent:", selectEvent, event?.label);
    let designationState = { ...OTData };

    if (event?.target === undefined && selectEvent) {
      if (selectEvent.name === "maximumHours") {
        const lengthRegex = new RegExp("^[A-Za-z0-9]");
        if (lengthRegex.test(event?.label) === true) {
          designationState[selectEvent.name + "Status"] =
            event?.label === undefined ? "unchecked" : "success";
        } else {
          designationState[selectEvent.name + "Status"] =
            selectEvent.value === "" ? "unchecked" : "error";
        }
      }
      designationState[selectEvent.name] = event;
    } else {
      const changeAllowed = true;
      switch (event.target.name) {
        case "otPerhourCharge":
          {
            const numericLengthRegex = new RegExp("^\\d{1,15}$");

            if (numericLengthRegex.test(event.target.value?.trim())) {
              designationState[event.target.name + "Status"] = "success";
            } else {
              designationState[event.target.name + "Status"] =
                event.target.value === "" ? "unchecked" : "error";
            }
          }
          break;
      }
      if (changeAllowed) {
        designationState[event.target.name] = event.target.value;
      }
    }
    setOTData(designationState);
  };

  const onfilterData = () => {
    const filterDepartment = resource.maximumHours.filter(
      (department) => department.maximumHours == viewData
    );
    console.log(
      "filterDepartment:",
      viewData,
      resource.maximumHours,
      filterDepartment
    );
    console.log("display:", display);
    setOTData({
      ...OTData,
      maximumHours: filterDepartment.map((department) => {
        return {
          value: department.id,
          label: department.maximumHours,
        };
      }),
    });
  };

  const onDiscardDesignation = () => {
    setTogglePage({
      view: true,
      edit: false,
    });

    setOTData({
      maximumHours: originalDesigntionData?.maximumHours,
      otPerhourCharge: originalDesigntionData?.otPerhourCharge,
    });

    // setupdate(false);
  };

  const handleAddDesignation = () => {
    setConfirmationDialog({
      open: true,
      title: "Confirmation",
      message: "Are you sure you want to submit your details?",
      showCancel: true,
      showConfirm: true,
      onConfirm: () => {
        onDesignationSubmit();
      },
      onCancel: () => {
        setConfirmationDialog({
          ...confirmationDialog,
          open: false,
        });
      },
    });
  };

  const toggleEdit = () => {
    setTogglePage({
      view: false,
      edit: true,
    });
    setupdate(true);
  };
  console.log(togglePage);

  const checkAllFields = () => {
    let allowSubmit = false;
    if (
      OTData.maximumHoursStatus === "success" &&
      OTData.otPerhourChargeStatus === "success"
    ) {
      allowSubmit = true;
    } else {
      allowSubmit = false;
    }
    return allowSubmit;
  };

  const checkFields = () => {
    let allowSubmit = false;
    if (
      OTData.maximumHours === originalDesigntionData.maximumHours &&
      OTData.otPerhourCharge === originalDesigntionData.otPerhourCharge
    ) {
      allowSubmit = false;
    } else if (OTData.maximumHours !== originalDesigntionData.maximumHours) {
      if (OTData.maximumHoursStatus === "success") {
        allowSubmit = true;
      } else {
        allowSubmit = false;
      }
    } else if (
      OTData.otPerhourCharge !== originalDesigntionData.otPerhourCharge
    ) {
      if (OTData.otPerhourChargeStatus === "success") {
        allowSubmit = true;
      } else {
        allowSubmit = false;
      }
    } else {
      allowSubmit = false;
    }
    return allowSubmit;
  };

  const handlecancel = () => {
    setConfirmationDialog({
      open: true,
      title: "Confirmation",
      message: "Are you sure you want to cancel?",
      showCancel: true,
      showConfirm: true,
      onConfirm: () => {
        onCancelAction(); // Call the function that handles cancel
        setConfirmationDialog({
          ...confirmationDialog,
          open: false,
        });
      },
      onCancel: () => {
        setConfirmationDialog({
          ...confirmationDialog,
          open: false,
        });
      },
    });
  };
  const onCancelAction = () => {
    navigate("/OTMaster");
  };

  return (
    <DashboardLayout>
      {confirmationDialog.open && (
        <ConfirmationDialog
          open={confirmationDialog.open}
          title={confirmationDialog.title}
          message={confirmationDialog.message}
          showCancel={confirmationDialog.showCancel}
          showConfirm={confirmationDialog.showConfirm}
          customSection={confirmationDialog.customSection}
          onConfirm={confirmationDialog.onConfirm}
          onCancel={confirmationDialog.onCancel}
        />
      )}
      <Card>
        <CardHeader
          title={
            <>
              {togglePage.view === true || togglePage.edit === true ? (
                <Stack
                  direction="row"
                  justifyContent="space-between"
                  alignItems="center"
                  spacing={2}
                >
                  <Stack direction="column" spacing={0}>
                    <MaterialTypography variant="h5" fontWeight="medium">
                    {togglePage.view ? "View OT Details" : "Edit OT Details"}

                     
                    </MaterialTypography>
                  </Stack>

                  {AccessData &&
                    Array.isArray(AccessData) &&
                    AccessData.some(
                      (item) =>
                        item.component === "EditOTMaster" && item.can_access
                    ) &&
                    display && (
                      <>
                        <ButtonGroup
                          variant="outlined"
                          aria-label="button group"
                        >
                          <MaterialButton
                            variant="gradient"
                            color="dark"
                            onClick={toggleEdit}
                            startIcon={<EditIcon />}
                          >
                            Edit
                          </MaterialButton>

                          <MaterialButton
                            variant="gradient"
                            color="dark"
                            onClick={AddDelete}
                            startIcon={<DeleteIcon />}
                            //  sx={{
                            //   '&:focus:not(:hover)': {
                            //     backgroundColor: '#3F51B5d4 !important',
                            //     boxShadow: 'none !important',
                            //   },
                            // }}
                          >
                            Delete
                          </MaterialButton>
                        </ButtonGroup>
                      </>
                    )}
                </Stack>
              ) : (
                <Stack
                  direction="row"
                  justifyContent="space-between"
                  alignItems="center"
                  spacing={2}
                >
                  <Stack direction="column" spacing={0}>
                    <MaterialTypography variant="h5" fontWeight="medium">
                      Add OT Details
                    </MaterialTypography>
                  </Stack>
                </Stack>
              )}
            </>
          }
        />
        <CardContent sx={{ minHeight: "70vh" }}>
          <MaterialBox>
            <Grid container spacing={1}>
              <Grid size={{ xs: 5, sm: 4 }}>
                <MaterialBox lineHeight={0} display="inline-block">
                  <MaterialTypography
                    component="label"
                    variant="caption"
                    fontWeight="bold"
                  >
                    Maximum Hours <span style={{ color: "red" }}>*</span>
                  </MaterialTypography>
                </MaterialBox>
                <MaterialSelect
                  name="maximumHours"
                  value={OTData.maximumHours}
                  customStyles={{ optionPadding: 20 }}
                  onChange={handleDesignationDatachange} //selectedValue, event
                  //   options={Array.from({ length: 4 }, (_, i) => ({
                  //     value: `${i + 1}`,
                  //     label: `${i + 1} Hour${i + 1 > 1 ? "s" : ""}`,
                  //   }))}
                  options={houroption.map((value) => {
                    return {
                      value: value.value,
                      label: value.label,
                    };
                  })}
                  // options={departmentOptions}
                  error={OTData.maximumHoursStatus === "error" ? true : false}
                  success={
                    OTData.maximumHoursStatus === "success" ? true : false
                  }
                  isClearable
                  isDisabled={togglePage?.view ? true : false}
                />
              </Grid>
              <Grid size={{ xs: 5, sm: 4 }}>
                <MaterialBox lineHeight={0} display="inline-block">
                  <MaterialTypography
                    component="label"
                    variant="caption"
                    fontWeight="bold"
                  >
                    Amount Per Hour <span style={{ color: "red" }}>*</span>
                  </MaterialTypography>
                </MaterialBox>
                {display ? (
                  <MaterialInput
                    name="otPerhourCharge"
                    placeholder="eg. 500"
                    value={OTData.otPerhourCharge}
                    onChange={handleDesignationDatachange}
                    error={OTData.otPerhourChargeStatus === "error"}
                    success={OTData.otPerhourChargeStatus === "success"}
                    disabled={togglePage?.view ? true : false}
                  />
                ) : (
                  <MaterialInput
                    name="otPerhourCharge"
                    placeholder="eg. 500"
                    value={OTData.otPerhourCharge}
                    onChange={handleDesignationDatachange}
                    error={OTData.otPerhourChargeStatus === "error"}
                    success={OTData.otPerhourChargeStatus === "success"}
                    icon={{
                      direction: "right",
                      component: <CurrencyRupeeIcon size={18} color="black" />,
                    }}
                  />
                )}
                {OTData.otPerhourChargeStatus === "error" && (
                  <FormControl error>
                    <FormHelperText>Only Enter Amounts</FormHelperText>
                  </FormControl>
                )}
              </Grid>
            </Grid>
          </MaterialBox>
        </CardContent>
        <MaterialBox
          display="flex"
          justifyContent="flex-end"
          alignItems="center"
        >
          {/* {
                        togglePage.edit === true
                            ?
                            <>

                                <MaterialButton
                                    variant="gradient"
                                    color="dark"
                                    onClick={onDiscardDesignation}
                                >
                                    Discard
                                </MaterialButton>

                                <MaterialButton
                                    sx={{ m: 2 }}
                                    variant="gradient"
                                    color="dark"
                                    disabled={
                                        !checkFields()
                                    }

                                    onClick={onDesignationSubmit}
                                >
                                    Submit
                                </MaterialButton>
                            </>
                            :
                            (togglePage.view === false && togglePage.edit === false) ?

                                <MaterialButton
                                    sx={{ m: 2 }}
                                    variant="gradient"
                                    color="dark"
                                    disabled={!checkAllFields()}
                                    onClick={handleAddDesignation}
                                >
                                    Add
                                </MaterialButton>
                                :
                                null
                    } */}

          {togglePage.edit === true && (
            <>
              <MaterialButton
                variant="gradient"
                color="dark"
                onClick={onDiscardDesignation}
              >
                Discard
              </MaterialButton>

              <MaterialButton
                sx={{ m: 2 }}
                variant="gradient"
                color="dark"
                // disabled={!checkFields()}
                onClick={onEditDesignationSubmit}
              >
                Update
              </MaterialButton>
            </>
          )}

          {!display && (
            <>
            <MaterialButton
                                sx={{ m: 2 }}
                                variant="gradient"
                                color="dark"
                                onClick={handlecancel}
                              >
                                Cancel
                              </MaterialButton>
            <MaterialButton
            sx={{ m: 2, marginLeft: "4px" }}
              variant="gradient"
              color="dark"
              disabled={!checkAllFields()}
              onClick={handleAddDesignation}
            >
              Submit
            </MaterialButton>
            </>
          )}
        </MaterialBox>
        {
          <MaterialSnackbar
            color="success"
            icon={<NotificationsIcon />}
            title="Message"
            content="You have been submitted successfully"
            open={snackBar.Success}
            close={() =>
              setSnackBar({
                success: false,
              })
            }
          />
        }
      </Card>
    </DashboardLayout>
  );
};

export default AddOT;
